import { makeStyles } from "../../../lib/mui-imports";

const useBootstrapStyles = makeStyles(
    {
        "build-container": {
            position: "relative",
            width: "100%",
            height: "100%",

            "@global": {
                "#app": {
                    width: "100%",
                    height: "100%",
                },
            },
        },

        "build-content": {
            height: "100%",

            "& *": {
                // outline: "1px solid dodgerblue",
                // outlineOffset: "-1px",
            },
        },

        "build-sidebar-container": {
            position: "fixed",
            top: 0,
            right: 0,
            height: "100%",

            display: "flex",
            alignItems: "center",

            "& .build-sidebar-content": {
                display: "grid",
                gridGap: "4px",

                padding: "4px 0",
                borderRadius: "4px 0 0 4px",
                backgroundColor: "#ffffff",
                filter: "drop-shadow(0 0 4px gray)",
            },

            "& button": {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "48px",
                height: "48px",
                border: "none",
                borderRadius: "4px",
                backgroundColor: "#f2f2f2",

                "& img, svg": {
                    width: "80%",
                    filter: "grayscale(1) brightness(0.5)",
                },

                "&:not(:disabled)": {
                    cursor: "pointer",
                },

                "&.active": {
                    backgroundColor: "#64b5f6",
                },
            },

            "& .text": {
                transition: "all 250ms ease",

                "&:hover": {
                    color: "#ffffff",
                    backgroundColor: "#64b5f6",
                },
            },

            "& .apply-lpb": {
                width: "96px",
                fontWeight: "bold",
            },

            "& .icon": {
                backgroundImage: "none",
                backgroundPosition: "center",
                backgroundSize: "65%",
                backgroundRepeat: "no-repeat",

                transition: "all 250ms ease",

                "&.icon-dice": {
                    backgroundImage: "url(/img/dice-black.svg)",
                },

                "&.icon-pgbldr": {
                    backgroundImage: "url(/img/logotype.svg)",
                },

                "&:hover": {
                    backgroundSize: "75%",
                    backgroundColor: "#64b5f6",
                },
            },

            "& .space": {
                display: "block",
                height: "8px",
            },
        },
    },
    { name: "BootstrapStyles" }
);

export default useBootstrapStyles;
